import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getFileExtension, toBase64 } from '../../../utils/util';

import {
  requestCreateTutorial,
  requestRetrieveTutorials,
  requestUpdateTutorial,
  requestDeleteTutorial,
} from '../../../api/help/help.actions';
import { requestDownloadDocument } from '../../../api/document/document.actions';

import Tutorials from '../../../components/screens/help-center/tutorials/Tutorials';

const TutorialsContainer = () => {
  const userGroups = useSelector(({ party }) => party.userGroups);
  const tutorials = useSelector(({ helpCenter }) => helpCenter.tutorials);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestRetrieveTutorials());
  }, [dispatch]);

  const createTutorial = async (tutorial, onSuccess) => {
    const { text, file, link } = tutorial;

    dispatch(
      requestCreateTutorial({
        input: {
          tutorialText: text,
          name: file ? file.name : undefined,
          documentExtension: file ? getFileExtension(file.name) : undefined,
          base64String: file ? await toBase64(file) : undefined,
          videoLink: link ? link : undefined,
        },
        onSuccess,
      })
    );
  };

  const updateTutorial = async (tutorial, onSuccess) => {
    const { externalReference, text, file, link } = tutorial;

    let name;
    let documentExtension;
    let base64String;
    let linkedMediaExternalReference;

    if (file && file.externalReference) {
      linkedMediaExternalReference = file.externalReference;
      name = file.name;
      documentExtension = getFileExtension(file.name);
    } else if (file) {
      name = file.name;
      documentExtension = getFileExtension(file.name);
      base64String = await toBase64(file);
    }

    dispatch(
      requestUpdateTutorial({
        input: {
          tutorialExternalReference: externalReference,
          tutorialText: text,
          videoLink: link,
          linkedMediaExternalReference,
          name,
          documentExtension,
          base64String,
        },
        onSuccess,
      })
    );
  };

  const deleteTutorial = (externalReference) => {
    dispatch(requestDeleteTutorial({ externalReference }));
  };

  const downloadDocument = (externalReference, name) => {
    dispatch(requestDownloadDocument({ externalReference, name }));
  };

  const isAdmin = userGroups.includes('admin');

  return (
    <Tutorials
      isAdmin={isAdmin}
      tutorials={tutorials}
      createTutorial={createTutorial}
      updateTutorial={updateTutorial}
      deleteTutorial={deleteTutorial}
      downloadDocument={downloadDocument}
    />
  );
};

export default TutorialsContainer;
